import * as React from 'react';
import { TextInput, TextInputProps } from '@mantine/core';

interface DebouncedInputProps extends Omit<TextInputProps, 'onChange'> {
    value: string | number;
    onChange: (value: string | number) => void;
    debounce?: number;
}

export const DebouncedInput = React.forwardRef<HTMLInputElement, DebouncedInputProps>(
    ({ value: initialValue, onChange, debounce = 500, ...props }, ref) => {
        const [value, setValue] = React.useState(initialValue);

        React.useEffect(() => {
            setValue(initialValue);
        }, [initialValue]);

        React.useEffect(() => {
            const timeout = setTimeout(() => {
                onChange(value);
            }, debounce);

            return () => clearTimeout(timeout);
        }, [value]);

        return <TextInput ref={ref} {...props} value={value} onChange={(e) => setValue(e.target.value)} />;
    }
);
